
import React, { createContext, useState } from 'react'

const BrandContext=createContext()

export const BrandProvider = ({children}) => {
  const [brand, setBrand] = useState({})
  const [brands,setBrands]=useState([])
  return (
    <BrandContext.Provider value={{brand,setBrand,brands,setBrands}}>
      {children}
    </BrandContext.Provider>
  )
}

export default BrandContext
